<template>
  <div class="current-card">
    <div v-if="photo" class="photo"><img :src="photoUrl" :alt="name"></div>
    <h1 v-if="name" class="name">{{ name }}</h1>
    <div class="desc">{{ description }}</div>

    <div v-if="type === 'textField'" class="form form--text">
      <input @keyup.enter="nextCard" v-model="userAnswer" :placeholder="$t('quiz.input')">
    </div>

    <div v-else-if="type === 'singleSelect'" class="form form--radio">
      <v-radio-group v-model="userAnswer">
        <v-radio v-for="(option, index) in options" :key="index" :label="option" :value="option" dark></v-radio>
    </v-radio-group>
    </div>

    <button @click="nextCard" type="button" class="submit" :disabled="userAnswer.length == 0">
      {{ $t("quiz.next") }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'QuizCard',
  data() {
    return {
      userAnswer: ''
    }
  },
  props: {
    type: String,
    name: String,
    photo: String,
    description: String,
    answer: String,
    options: Array,
  },
  computed: {
    photoUrl: function() {
      return require(`@/assets/${ this.photo }`)
    },
    isAnswerCorrect: function() {
      return this.answer == this.userAnswer
    }
  },
  methods: {
    nextCard: function() {
      const form = document.querySelector('.form')
      const submit = document.querySelector('.submit')

      if (this.userAnswer.length == 0) return
      if (this.isAnswerCorrect) this.$emit('update-card')

      else {
        form.classList.add('has-error')
        form.addEventListener('animationend', () => form.classList.remove('has-error'))
      }

      // Reset form
      this.userAnswer = ''
      submit.blur()
    }
  }
}
</script>

<style scoped lang="scss">
$spacer: 2rem;
$success: #4CAF50;
$danger: #ef5350;

@keyframes shake {
  10%, 90% { transform: translate3d(-1px, 0, 0); }
  20%, 80% { transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
  40%, 60% { transform: translate3d(4px, 0, 0); }
}

.current-card {
  background: #fff;
  box-shadow: 0 0 3rem rgba(#000, .15);
}
.name {
  padding-top: $spacer;
  margin: 0 $spacer $spacer;
}
.photo {
  text-align: center;
  background: #FAFAFA;
  padding: $spacer;

  img { display: inline-block; }
}
.desc {
  margin: $spacer;
}
.form {
  color: #fff;
  background: #37474F;
  transition: background 250ms;

  &--radio {
    padding: $spacer;
  }

  input {
    color: #fff;
    font-size: 1.5rem;
    background: none;
    padding: $spacer;
    width: 100%;

    &:focus {
      outline: 0;
    }
  }

  &.has-error {
    background: $danger;
    animation: shake 1s ease-in-out;
  }
}
.submit {
  color: #fff;
  font-weight: bold;
  font-size: 1.15rem;
  text-align: center;
  padding: 1rem;
  background: $success;
  display: block;
  width: 100%;
  transition: background 250ms ease-in-out, opacity 250ms ease-in-out;
  cursor: pointer;

  &[disabled] {
    opacity: .75;
    pointer-events: none;
  }

  &:hover {
    background: lighten($success, 5%);

  }

  &:focus {
    background: darken($success, 5%);
    box-shadow: 0 0 0 .25rem rgba($success, .5);
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
